import request from '@/utils/request'
import Exports from '@/utils/export'

// 查询缺陷管理列表--分页数据
export function getDefectList(searchForm) {
  return request({
    url: 'task/bugList',
    method: 'post',
    data: searchForm
  })
}

// 提交验收 task/bugList
export function submitCheckData(tb_id, user_id) {
  return request({
    url: 'task/bugList',
    method: 'post',
    data: {
      task_bug_id: tb_id,
      user_id: user_id
    }
  })
}

export function exportTaskBug(data) {
  return Exports({
    url: '/task/exportTaskBug',
    method: 'post',
    data: data
  })
}
export function bugList(data) {
  return request({
    url: '/task/bugList',
    method: 'post',
    data
  })
}
export function bugAddUpdate(data) {
  return request({
    url: '/task/bugAddUpdate',
    method: 'post',
    data
  })
}
// 关闭
export function bugClose(data) {
  return request({
    url: '/task/bugClose',
    method: 'post',
    data
  })
}
// 废弃
export function bugAbandoned(data) {
  return request({
    url: '/task/bugAbandoned',
    method: 'post',
    data
  })
}
// 通过
export function bugSubmitPass(data) {
  return request({
    url: '/task/bugSubmitPass',
    method: 'post',
    data
  })
}
// 驳回
export function bugSubmitRejection(data) {
  return request({
    url: '/task/bugSubmitRejection',
    method: 'post',
    data
  })
}
// 驳回
export function bugSubmitTest(data) {
  return request({
    url: '/task/bugSubmitTest',
    method: 'post',
    data
  })
}
// 验收
export function bugSubmitAcceptance(data) {
  return request({
    url: '/task/bugSubmitAcceptance',
    method: 'post',
    data
  })
}
// 已解决
export function bugDraft(data) {
  return request({
    url: '/task/bugDraft',
    method: 'post',
    data
  })
}

export function bugResolved(data) {
  return request({
    url: '/task/bugResolved',
    method: 'post',
    data
  })
}
// 已解决
export function bugModifiedUser(data) {
  return request({
    url: '/task/bugModifiedUser',
    method: 'post',
    data
  })
}
// 获取测试用例接口
export function getTestCaseList(demandId) {
  return request({
    url: `/xian/test/case/getCaseInfo/${demandId}`,
    method: 'GET',
  })
}
// 根据demandid查询测试用例信息
export function getTestCaseById(demandId) {
  return request({
    url: `${process.env.VUE_APP_MS_API}/test/case/addCaseRelevance/${demandId}`,
    method: 'GET',
  })
}
/*
  缺陷工时记录
*/
// 缺陷工时列表
export function getDefectWorkList(data) {
  return request({
    url: '/bug/listBugTimes',
    method: 'post',
    data
  })
}
// 缺陷工时新增
export function addDefectWork(data) {
  return request({
    url: '/bug/addBugTimes',
    method: 'post',
    data
  })
}
// 缺陷工时删除
export function deleteDefectWork(data) {
  return request({
    url: '/bug/deleteBugTimes',
    method: 'post',
    data
  })
}
// 缺陷工时修改
export function updateDefectWork(data) {
  return request({
    url: '/bug/editBugTimes',
    method: 'post',
    data
  })
}
